import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';
import getSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';

/**
 * Indicates if the given conversation/item is loaded in list view of input folder.
 * @param rowId conversation/item to be searched in list view
 * @param folderNameOrId folder of the list view
 */
export const isRowLoadedInFolder = (rowId: string, folderNameOrId: string): boolean => {
    const currentTableView = getSelectedTableView();
    const inputFolderId = folderNameToId(folderNameOrId) || folderNameOrId;
    if (currentTableView.tableQuery.folderId !== inputFolderId) {
        return false;
    }
    return currentTableView.itemIds.includes(rowId);
};
